import { Input } from "@/components/base/input/input";
import type { QuestionSettings } from "@/types/question";
import { parseNumericInput, sanitizeNumericInput } from "../../utils";

type TextSettingsProps = {
	settings: QuestionSettings;
	setSettings: (settings: QuestionSettings) => void;
};

export const TextSettings = ({ settings, setSettings }: TextSettingsProps) => (
	<div className="rounded-lg border border-gray-200 bg-white p-6">
		<h3 className="mb-4 font-semibold text-gray-900 text-lg">
			Configurações de Texto
		</h3>

		<div className="grid grid-cols-2 gap-4">
			<div>
				<label
					className="mb-2 block font-medium text-gray-700 text-sm"
					htmlFor="min-length"
				>
					Tamanho mínimo (caracteres)
				</label>
				<Input
					id="min-length"
					inputMode="numeric"
					maxLength={9}
					onChange={(value) => {
						const sanitized = sanitizeNumericInput(value);
						// Verificar se o valor tem mais de 9 dígitos
						if (sanitized.length > 9) {
							return; // Não atualiza o estado se exceder 9 dígitos
						}
						const numValue = parseNumericInput(sanitized);
						if (numValue !== undefined) {
							if (numValue < 0) {
								setSettings({ ...settings, minLength: 0 });
								return;
							}
							if (numValue > 999_999_999) {
								return; // Não atualiza se exceder o limite
							}
						}
						setSettings({ ...settings, minLength: numValue });
					}}
					placeholder="0"
					type="text"
					value={settings.minLength?.toString() ?? ""}
				/>
			</div>

			<div>
				<label
					className="mb-2 block font-medium text-gray-700 text-sm"
					htmlFor="max-length"
				>
					Tamanho máximo (caracteres)
				</label>
				<Input
					id="max-length"
					inputMode="numeric"
					maxLength={9}
					onChange={(value) => {
						const sanitized = sanitizeNumericInput(value);
						// Verificar se o valor tem mais de 9 dígitos
						if (sanitized.length > 9) {
							return; // Não atualiza o estado se exceder 9 dígitos
						}
						const numValue = parseNumericInput(sanitized);
						if (numValue !== undefined) {
							if (numValue < 0) {
								setSettings({ ...settings, maxLength: 0 });
								return;
							}
							if (numValue > 999_999_999) {
								return; // Não atualiza se exceder o limite
							}
							if (numValue <= 0) {
								return;
							}
						}
						setSettings({ ...settings, maxLength: numValue });
					}}
					placeholder="500"
					type="text"
					value={settings.maxLength?.toString() ?? ""}
				/>
				{settings.maxLength !== undefined && settings.maxLength <= 0 && (
					<p className="mt-1 text-red-600 text-xs">
						O valor deve ser maior que zero.
					</p>
				)}
			</div>
		</div>
	</div>
);
